import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw';
import {
  mapActions,
} from 'vuex';
import {
  SNACKBAR_TYPES,
} from '@/utils/constants';
import ScheduleSetting from '@/components/Order/ScheduleSetting/ScheduleSetting.vue';
import { GET_SCHEDULE } from '../../store/orders/constants';

dayjs.locale('zh-tw');

export default {
  name: 'ViewSchedule',
  components: {
    ScheduleSetting,
  },
  data() {
    return {
      loading: false,
      groupBuyings: {},
      groupBuyingSetting: {},
      scheduleSetting: {},
    };
  },
  async created() {
    try {
      this.loading = true;
      const { params: { scheduleId } = {} } = this.$route || {};
      if (scheduleId) {
        const {
          groupBuyings = {},
          groupBuyingSetting = {},
          scheduleSetting = {},
        } = await this.getSchedule(scheduleId);
        this.groupBuyings = groupBuyings;
        this.groupBuyingSetting = groupBuyingSetting;
        this.scheduleSetting = scheduleSetting;
      }
    } catch (error) {
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: '載入資訊失敗，請重新整理網頁。',
        msg: error?.message || '發生未知錯誤，請再試一次',
      });
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('orders', {
      getSchedule: GET_SCHEDULE,
    }),
    goBack() {
      this.$router.push({
        path: '/order/schedule',
      });
    },
  },
};
